import PropTypes from 'prop-types';
import { INLINE_MESSAGE_TYPES } from './types';

export const InlineMessageTypePropType = PropTypes.oneOf([
  INLINE_MESSAGE_TYPES.error,
  INLINE_MESSAGE_TYPES.warning,
  INLINE_MESSAGE_TYPES.info,
  INLINE_MESSAGE_TYPES.sublabel,
  '',
]);
